import { IAssetType } from "../../types/graphqlTypes";

export default function translateTypenameIntoAssetType(
  typename: "AmericanCompanyIssuer" | "BrazilianCompany" | "BrazilianRealEstateFund" | "BrazilianCompanyIssuer",
): IAssetType {
  if (typename === "AmericanCompanyIssuer") {
    return IAssetType.AmericanCompany;
  }

  if (typename === "BrazilianCompany") {
    return IAssetType.BrazilianCompany;
  }

  if (typename === "BrazilianCompanyIssuer") {
    return IAssetType.BrazilianCompany;
  }

  if (typename === "BrazilianRealEstateFund") {
    return IAssetType.BrazilianRealEstateFund;
  }

  throw new Error(`Unknown typename: ${typename}`);
}
